import React from 'react';

interface IconContrastProps {
    width?: number | string;
    height?: number | string;
    color?: string;
}

const IconContrast: React.FC<IconContrastProps> = ({
    width = 14,
    height = 14,
    color = 'black',
}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 14 14"
        fill="none"
    >
        <path
            d="M7.00003 0C3.14015 0 0 3.14014 0 6.99998C0 10.86 3.14015 14 7 14C10.86 14 14 10.86 14 6.99998C14 3.14014 10.86 0 7.00003 0ZM0.792373 6.99998C0.792373 3.57717 3.57718 0.792371 7.00003 0.792371V13.2076C3.57714 13.2076 0.792373 10.4228 0.792373 6.99998Z"
            fill={color}
        />
    </svg>
);

export default IconContrast;
